import React from 'react';
import MainTabbedView from './components/MainTabbedView';
import { DemoProvider } from './context/DemoContext';
import useDemoOrchestrator from './hooks/useDemoOrchestrator';

function DemoApp() {
  useDemoOrchestrator();
  
  return (
    <div className="demo-container">
      {/* Main Layout - Single Header */}
      <div className="demo-content">
        <MainTabbedView />
      </div>
    </div>
  );
}

function App() {
  return (
    <DemoProvider>
      <DemoApp />
    </DemoProvider>
  );
}

export default App;
